import * as types from '../actions/actionTypes';

export const setTourEnabled = (tour, enabled) => {
    return { type: types.TOUR_ENABLED_CHANGED, tour: tour, enabled: enabled };
};


// WEBPACK FOOTER //
// ./src/js/actions/tourActionCreators.js